import {
    COUNTRY_MAPPING_SUCCESS,
    COUNTRY_MAPPING_FAILED,
    LOADING_COUNTRY_MAPPING,
    NETWORK_ERROR_COUNTRY_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminCountryMappingAction =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_COUNTRY_MAPPING });
        await adminServices
            .post("countryMapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: COUNTRY_MAPPING_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: COUNTRY_MAPPING_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_COUNTRY_MAPPING,
                    payload: err
                });
            });
    };

export { adminCountryMappingAction };
